module.exports = __webpack_public_path__ + "img/basement.ace43d4.svg";